export enum EnumSubTipoComunicacion {
  EventoCliente = 1,
  FacturaEmitida = 2,
  NotaConfirmacion = 3,
  EventoInterno = 4
}
